import { useState, useEffect } from 'react';

function useTouchDetect(): boolean {
  const [isTouching, setIsTouching] = useState<boolean>(false);
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  
  useEffect(() => {
    let startX: number = 0;
    let startY: number = 0;
    const threshold = 15;

    const handleTouchStart = (event: TouchEvent) => {
      const touch = event.touches[0];
      startX = touch.pageX;
      startY = touch.pageY;
      setIsTouching(true);
      setIsScrolling(false);
    };

    const handleTouchMove = (event: TouchEvent) => {
      const touch = event.touches[0];
      const deltaX = Math.abs(touch.pageX - startX);
      const deltaY = Math.abs(touch.pageY - startY);

      if (deltaX > threshold || deltaY > threshold) {
        setIsScrolling(true);
        setIsTouching(false);
      }
    };

    const handleTouchEnd = () => {
      if (!isScrolling) {
        console.log('Tap detected');
      }
      setIsTouching(false);
    };

    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isScrolling]);

  return isTouching && !isScrolling;
}

export default useTouchDetect;
